import { Popper, styled } from '@mui/material';

export const LocationMobilePopper = styled(Popper, {
  shouldForwardProp: (property) => property !== 'disableRightBorderRadius',
})<{
  disableRightBorderRadius?: boolean;
}>`
  /* Remove absolute positioning for mobile - render in place */
  position: static !important;
  width: 100% !important;
  transform: none !important;
  z-index: auto !important;

  .MuiPaper-root {
    width: 100%;
    margin-top: 8px;
    border: none;
    box-shadow: none;

    & > .MuiAutocomplete-listbox {
      padding: 8px 0;
      max-height: unset;
    }
  }

  .MuiAutocomplete-noOptions {
    display: none;
  }

  .MuiAutocomplete-listbox {
    .MuiAutocomplete-option {
      padding: 0;

      &.Mui-focused,
      &:hover {
        background-color: rgba(0, 0, 0, 0.04);
      }
    }
  }
`;
